import React from "react";
import { IconType } from "react-icons";

interface IconProps {
  icon: IconType;
  size?: number | string;
  color?: string;
  className?: string;
  style?: React.CSSProperties;
  onClick?: () => void;
}

const Icon: React.FC<IconProps> = ({
  icon: IconComponent,
  size,
  color,
  className,
  style,
  onClick,
}) => {
  return (
    <IconComponent
      size={size}
      color={color}
      className={className}
      style={style}
      onClick={onClick}
    />
  );
};

export default Icon;
